import React, { useEffect, useMemo, useState } from 'react';
import Steppers from '../../../Common/Stepper/Stepper';
import GuestChooseDate from './Steps/GuestChooseDate';
import GuestUserInfo from './Steps/GuestUserInfo';
import GuestPayment from './Steps/GuestPayment';
import { bookConsultApi, getAddonClassApi, getVirtualClassDateApi, getAvilableDatesApi } from '../../../Service/Cousult.service';
import { getDataFromLocalStorage } from '../../../Service/getLocalStorage';
import CongratsModel2 from '../../../Common/CongratsPopup2/CongratsPopup2';
import { GIFTCARD } from '../../../Routes/RouteConstent';
import dayjs from 'dayjs';
import isMebershipAndActiveCheck from '../../../Utils/membership_check';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useQuery } from '../../../Hooks/useQuery';
import { capturePurchasedServiceEvent, useCaptureServiceEvent } from '../../../Service/serviceData';
import { 
  saveGuestBookingData, 
  getGuestBookingData, 
  clearGuestBookingData, 
  GuestBookingData 
} from '../../../Utils/guestBookingStorage';
import SignupPopup from '../../../Utils/Popup/Signup';
import { isUserLoggedInAction } from '../../../Redux/user/user';

const GuestVirtualLactationConsult = ({ state }: any) => {
  console.log('GuestVirtualLactationConsult component rendering', { state });
  const [activeStep, setActiveStep] = useState(0);
  const [hostData, setHostData] = useState<any>([]);
  const [classData, setClassData] = useState<any>([]);
  const [dateVisible, setDateVisible] = useState<Array<number>>([]);
  const [date, setDate] = useState<any>({});
  const [serviceId, setServiceId] = useState<any>();
  const [formField, setFormField] = useState<any>([]);
  const [classTime, setClassTime] = useState<any>([]);
  const [userInfoVal, setUserInfoVal] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingWash, setLoadingWash] = useState<boolean>(false);
  const [modelOpen, setModelOpen] = useState<boolean>(false);
  const [term_condition, setPolicy] = useState<any>(false);
  let [price, setPrice] = useState<any>("");
  const [slots, setSlots] = useState<any>({});
  const [priceArry, setPriceArry] = useState<any>([]);
  const [addOn, setAddOn] = React.useState<any>([]);
  const [hostObj, setHostObj] = useState<any>({});
  const [objName, setObjName] = useState<any>({});
  const [serviceName, setServiceName] = useState<any>({});
  const [priceDisplay, setPriceDisplay] = useState<any>({
    price: price,
    actualPrice: price
  });
  const [selectClasses, setSelectClasses] = useState<any>([]);
  const [selectSlots, setSelectSlots] = useState<any>([]);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState<boolean>(false);
  const [guestData, setGuestData] = useState<GuestBookingData>({});

  let steps = [1, 2, 3, 4]; // Added signup step

  const serviceParam = useQuery().get('service') || state?.param || 'service_3';
  console.log('serviceParam:', serviceParam);

  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const isCheck = (res: any) => {
    isMebershipAndActiveCheck(res, Navigate, toast, dispatch);
  };

  const stepNames = useMemo(
    () => ['date-bundle-step', 'user-step', 'signup-step', 'payment-step'],
    []
  );

  const requestParams = useMemo(() => {
    const localData = getDataFromLocalStorage() || {};

    return {
      ...date,
      ...userInfoVal,
      due_date: userInfoVal.due_date ? dayjs(userInfoVal.due_date).format("YYYY-MM-DD") : undefined,
      email: localData.email || userInfoVal.email,
      service_id: serviceId,
      service_name: serviceParam,
      first_name: localData.first_name || userInfoVal.first_name,
      last_name: localData.last_name || userInfoVal.last_name,
      user_id: localData.id,
      phone: localData.phone || userInfoVal.phone,
    };
  }, [date, serviceId, serviceParam, userInfoVal]);

  useCaptureServiceEvent(activeStep, stepNames);

  // Load guest data on component mount
  useEffect(() => {
    const savedGuestData = getGuestBookingData();
    if (savedGuestData) {
      setGuestData(savedGuestData);
      
      // Restore form data if available
      if (savedGuestData.appointmentData) {
        setDate(savedGuestData.appointmentData);
      }
      if (savedGuestData.userInfo) {
        setUserInfoVal(savedGuestData.userInfo);
      }
      if (savedGuestData.price) {
        setPrice(savedGuestData.price);
        setPriceDisplay({
          price: savedGuestData.price,
          actualPrice: savedGuestData.price
        });
      }
    }
  }, []);

  // Save guest data whenever form data changes
  useEffect(() => {
    if (Object.keys(date).length > 0 || Object.keys(userInfoVal).length > 0) {
      saveGuestBookingData({
        appointmentData: date,
        userInfo: userInfoVal,
        price: price,
        selectedService: serviceParam
      });
    }
  }, [date, userInfoVal, price, serviceParam]);

  function getStepContent(step: number) {
    switch (step) {
      case 0:
        return (
          <GuestChooseDate
            hostObj={hostObj}
            objName={objName}
            host={hostData}
            data={classData}
            handleNext={handleNext}
            dateVisible={dateVisible}
            loadingWash={loadingWash}
            setDateVisible={setDateVisible}
            value={date}
            setValue={setDate}
            price={price}
            setPrice={setPrice}
            setObjName={setObjName}
            slots={slots}
            setSlots={setSlots}
            allData={serviceName}
            setAddOn={setAddOn}
            setSelectClasses={setSelectClasses}
            setSelectSlots={setSelectSlots}
            setClassTime={setClassTime}
            priceArry={priceArry}
            setPriceArry={setPriceArry}
            setPriceDisplay={setPriceDisplay}
            addOn={addOn}
            selectClasses={selectClasses}
            selectSlots={selectSlots}
            priceDisplay={priceDisplay}
          />
        );
      case 1:
        return (
          <GuestUserInfo
            handleNext={handleNext}
            value={userInfoVal}
            setValue={setUserInfoVal}
            handlePrev={handlePrev}
            setPolicy={setPolicy}
            term_condition={term_condition}
            field={formField}
          />
        );
      case 2:
        return (
          <div className="text-center p-5">
            <h3>Create Your Account</h3>
            <p>To complete your booking, please create an account. Your information has been saved and will be transferred to your new account.</p>
            <div className="booking-summary-preview mb-4 p-3 border rounded bg-light">
              <h5>Booking Summary</h5>
              <p><strong>Service:</strong> {date.service_name || 'Virtual Lactation Consultation'}</p>
              <p><strong>Date:</strong> {date.appointment_date_time ? dayjs(date.appointment_date_time).format('dddd, MMMM DD, YYYY') : 'Not selected'}</p>
              <p><strong>Time:</strong> {date.appointment_date_time ? dayjs(date.appointment_date_time).format('h:mm A') : 'Not selected'} EST</p>
              <p><strong>Price:</strong> ${date.total_ammount || priceDisplay.actualPrice || '325'}</p>
            </div>
            <button 
              className="btn primary-blue-btn btn-lg"
              onClick={() => setIsSignupModalOpen(true)}
            >
              Create Account & Continue
            </button>
          </div>
        );
      case 3:
        return (
          <GuestPayment
            serviceParams={requestParams}
            appointmentData={date}
            hostObj={hostObj}
            objName={objName}
            addOn={addOn}
            priceDisplay={priceDisplay}
            onBookingComplete={handleBookingComplete}
          />
        );
      default:
        return "Unknown step";
    }
  }

  const handleNext = () => {
    const localData = getDataFromLocalStorage();
    
    // If user is logged in and we're at step 1 (user info), skip to payment (step 3)
    if (localData?.id && localData?.is_email_verify != 0 && activeStep === 1) {
      setActiveStep(3); // Skip signup step, go directly to payment
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const handlePrev = () => {
    setActiveStep(activeStep - 1);
  };

  const handleSignupSuccess = (userData: any) => {
    // Get the full user data from localStorage (set by signup modal)
    const fullUserData = JSON.parse(localStorage.getItem("Nurture_user_data") || "{}");
    
    // Update user info with the new user data, preserving guest data
    setUserInfoVal({
      ...userInfoVal,
      first_name: fullUserData.first_name,
      last_name: fullUserData.last_name,
      email: fullUserData.email,
      phone: fullUserData.phone
    });

    // Update guest booking data with new user info
    saveGuestBookingData({
      userInfo: {
        ...userInfoVal,
        first_name: fullUserData.first_name,
        last_name: fullUserData.last_name,
        email: fullUserData.email,
        phone: fullUserData.phone
      }
    });

    setIsSignupModalOpen(false);
    handleNext(); // Move to payment step
  };

  const handleBookingComplete = () => {
    setModelOpen(true);
    clearGuestBookingData();
  };

  const getClassData = async () => {
    try {
      let prefix = {
        service_prefix: serviceParam
      };
      setLoadingWash(true);
      let res: any = await getVirtualClassDateApi(serviceParam, prefix);
      
      // Only check membership/auth for logged-in users
      const localData = getDataFromLocalStorage();
      if (localData && localData.id) {
        isCheck(res);
      }
      
      if (res?.data?.success) {
        console.log('Class data loaded successfully:', res?.data?.data);
        setHostData(res?.data?.data);
        setPrice(res?.data?.data[0]?.payment_price);
        setServiceId(res.data.service_id);
        setHostObj(res?.data?.data[0]);
        setServiceName(res?.data);
        
        // Fetch appointment availability for each calendar
        await fetchAppointmentAvailability(res?.data?.data);
        
        setLoadingWash(false);
      } else {
        console.error('Failed to load class data:', res?.data?.message);
        setLoadingWash(false);
      }
    } catch (err) {
      console.error('Error loading class data:', err);
      setLoadingWash(false);
    }
  };

  const fetchAppointmentAvailability = async (calendars: any[]) => {
    try {
      const availabilityPromises = calendars.map(async (calendar) => {
        try {
          const availabilityRes: any = await getAvilableDatesApi({
            acuity_calendar_id: calendar.calendar_id,
            acuity_appointment_type_id: calendar.acuity_appointment_type_id,
            year_date: new Date()
          });
          
          if (availabilityRes?.data?.success) {
            return {
              ...calendar,
              time: availabilityRes.data.data[0]?.time || null,
              slotsAvailable: availabilityRes.data.data[0]?.slotsAvailable || 0,
              slots: availabilityRes.data.data[0]?.slots || 0,
              price: calendar.payment_price
            };
          }
          return calendar;
        } catch (error) {
          console.error('Error fetching availability for calendar:', calendar.id, error);
          return calendar;
        }
      });
      
      const updatedCalendars = await Promise.all(availabilityPromises);
      setHostData(updatedCalendars);
    } catch (error) {
      console.error('Error fetching appointment availability:', error);
    }
  };

  const getAddonClass = async () => {
    try {
      let res: any = await getAddonClassApi({ service_prefix: serviceParam });
      
      // Only check membership/auth for logged-in users
      const localData = getDataFromLocalStorage();
      if (localData && localData.id) {
        isCheck(res);
      }
      
      if (res?.data?.success) {
        setClassData(res?.data?.data);
      } else {
        console.error('Failed to load addon class data:', res?.data?.message);
      }
    } catch (err) {
      console.error('Error loading addon class data:', err);
    }
  };

  useEffect(() => {
    console.log('useEffect: Loading class data for service:', serviceParam);
    getAddonClass();
    getClassData();
  }, []);

  useEffect(() => {
    setPrice(date?.total_ammount);
  }, []);

  useEffect(() => {
    setPriceDisplay({
      price: price,
      actualPrice: price
    });
  }, [price]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      //@ts-ignore
      behavior: 'instant',
    });
  }, [activeStep]);

  const popUpCallback = () => {
    getAddonClass();
    getClassData();
    setActiveStep(0);
  };

  return (
    <div>
      <SignupPopup
        isSignup={isSignupModalOpen}
        setIsSignup={setIsSignupModalOpen}
        setData={handleSignupSuccess}
        setIsVerifyEmail={() => {}}
        setIslogin={() => {}}
        handelClose={() => setIsSignupModalOpen(false)}
        skipEmailVerification={true}
        prefillData={userInfoVal}
      />

      <CongratsModel2
        open={modelOpen}
        setOpen={setModelOpen}
        btnText="Send gift card to your friend"
        Page={GIFTCARD}
        callBack={() => popUpCallback()}
        text={'All information about your upcoming appointment has been sent to your email.<br>In the meantime, feel free to check out our other offerings, or if you have a friend who you think would be interested in the same booking as you, tell them using the button below!'} 
        title="Thank you for booking with NAPS!" 
      />

      {loadingWash ? (
        <div className="text-center p-5">
          <h3>Loading...</h3>
          <p>Please wait while we load the available appointments.</p>
        </div>
      ) : (
        <Steppers 
          steps={steps} 
          getStepContent={getStepContent}
          activeStep={activeStep} 
          setActiveStep={setActiveStep}
          handleNext={handleNext}
        />
      )}
    </div>
  );
};

export default GuestVirtualLactationConsult;
